import { Component } from '@angular/core';
import { CircularDetectionService } from '../../../utilities/circular-detection/circular-detection.service';

@Component({
  selector: 'sg2-admin-tools-find-circular',
  templateUrl: './admin-tools-find-circular.component.html',
  styleUrls: ['./admin-tools-find-circular.component.less']
})
export class AdminToolsFindCircularComponent {

  constructor(
    private circularDetectionService: CircularDetectionService
  ) { }

  /**
   * Find circular errors in AngularJs $scope.
   */
  public findInScope(): void {
    this.circularDetectionService.findInScope();
  }

  /**
   * Find circular errors in Angular Datastore.
   */
  public findInStore(): void {
    this.circularDetectionService.findInStore();
  }
}
